import { render, staticRenderFns } from "./FiltersListSection.vue?vue&type=template&id=3aa1d46a&scoped=true&functional=true&"
var script = {}
import style0 from "./FiltersListSection.vue?vue&type=style&index=0&id=3aa1d46a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3aa1d46a",
  null
  
)

export default component.exports